import React  from 'react'

export default function renderDateGroupTListHeader1(id, props) {
    return (
        <>
            <div className="text ui5-txt-default">{props.data.name}</div>
        </>
    );
}